import SecondaryButton from './scondary-button'
export default SecondaryButton
